import React from "react";

const TermsAndConditions = () => {
  return (
    <div class="max-w-[1280px] mx-auto p-6 leading-8">
      <div class="title">
        <h1 class="text-center text-[28px] font-semibold  px-2 text-secondary">TERMS &amp; CONDITIONS</h1>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 1 Summary
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">1.1</strong> It is essential that
            you read and understand these terms, as they apply to all bookings
            made through our Website for services provided by Parking Providers.
            They outline how to make, amend, or cancel bookings. By making a
            booking on our Website, you agree to be bound by these terms.
          </li>
          <li>
            <strong class=" px-2 text-secondary">1.2</strong>
            When you purchase parking services via our Website or over the
            phone, you are also subject to the terms and conditions of the
            Parking Provider (referred to as "Parking Provider Terms"). It is
            your responsibility to read and understand the relevant Parking
            Provider Terms for the parking service you are booking.
          </li>
          <li>
            <strong class=" px-2 text-secondary">1.2.1</strong>
            We act solely as a booking agent for Parking Providers. We do not
            provide or operate the parking services directly. By booking through
            our Website, you acknowledge and agree that we are not responsible
            for the supply or delivery of these services. This responsibility
            lies with the Parking Provider.
          </li>
          <li>
            <strong class=" px-2 text-secondary">1.2.2</strong>
            Any claims related to the supply or delivery of parking services
            should be directed to the Parking Provider, as these are subject to
            their terms and conditions.
          </li>
          <li>
            <strong class=" px-2 text-secondary">1.2.3</strong>
            Your booking is also subject to our Privacy Policy and Cookies
            Policy
          </li>
          <li>
            <strong class=" px-2 text-secondary">1.2.4</strong>
            These terms may be updated at any time without prior notice.
            However, the terms applicable to your booking are those displayed on
            the Website at the time of your booking. We recommend reviewing
            these terms before making a booking to ensure you accept them.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 2 Definitions
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">2.1</strong>
            The following definitions apply to these terms:
          </li>
          <ul class="px-5">
            <li >
              <strong class=" px-2 text-secondary">Booking Confirmation:</strong>The
              email confirmation sent by us or the Parking Provider after you
              complete a booking.
            </li>
            <li >
              <strong class=" px-2 text-secondary">Parking Service:</strong>: The
              parking service offered for booking on our Website.
            </li>
            <li >
              <strong class=" px-2 text-secondary">Parking Provider: </strong>The
              third-party company operating the parking service you are booking
              through the Website
            </li>
            <li >
              <strong class=" px-2 text-secondary">Parking Provider Terms: </strong>
              The terms and conditions of the Parking Provider that apply to the
              parking service you book
            </li>
            <li >
              <strong class=" px-2 text-secondary">Website: </strong>The website you
              are using to make your booking
            </li>
          </ul>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 3 Who We Are and What We Do
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">3.1</strong>
            We are Holiday Comparison Ltd , a company registered in England and
            Wales (company number: 15801332). Our registered office address is
            71-75, Shelton Street, Covent Garden London, United Kingdom, WC2H
            9JQ.
          </li>
          <li class="text-center px-5">
            We facilitate bookings for parking services provided by third-party
            Parking Providers. However, we do not own, operate, or supply the
            parking services listed on our Website.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 4 Our Liability{" "}
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">4.1</strong>
            We act solely as a booking agent for Parking Providers whose
            services are booked through our Website. Therefore, you acknowledge
            and agree that:
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.1.1</strong>
            We are not responsible for providing or fulfilling the parking
            services (see paragraph 5.2.2 below). We are also not liable if the
            parking services you book do not meet your expectations or are
            unsuitable for your needs.
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.1.2</strong>
            Our liability is limited to direct losses resulting from our
            negligence in processing your booking, subject to paragraph 4.3
            below.
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.2</strong>
            We do not accept responsibility or liability for any loss or damage
            arising from:
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.2.1</strong>
            Incorrect, incomplete, or misleading information you provide on the
            Website, such as an inaccurate email address or contact number
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.2.2</strong>
            The accuracy or content of reviews displayed on the Website related
            to parking services
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.2.3</strong>
            Acts, omissions, errors, or defaults of Parking Providers or any
            third parties responsible for delivering the parking services booked
            through the Website.
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.2.4</strong>
            Costs incurred in purchasing replacement services due to errors or
            omissions by a Parking Provider or third party.
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.2.5</strong>
            Losses not foreseeable by you and us at the time of booking
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.2.6</strong>
            Losses related to the use of parking services for trade, business,
            craft, or professional purposes, including loss of profit, revenue,
            data, or earnings
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.3</strong>
            You are responsible for ensuring you allow sufficient time to use
            the parking service you have booked.
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.4</strong>
            Nothing in these terms excludes or limits our liability for death or
            personal injury caused by our negligence, fraud, or any liability
            that cannot be excluded under applicable law.
          </li>
          <li>
            <strong class=" px-2 text-secondary">4.5</strong>
            Our total liability for claims arising from the use of the Website
            is limited to the total cost of your booking, including any booking
            fees paid to us.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 5 Parking Services and Parking Providers
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">5.1</strong>
            Our Website facilitates bookings for parking services provided by
            third-party Parking Providers
          </li>
          <li>
            <strong class=" px-2 text-secondary">5.2</strong>
            When you book a parking service via the Website, you agree that:
          </li>
          <li>
            <strong class=" px-2 text-secondary">5.2.1</strong>
            Your booking creates a contract between you and the Parking
            Provider, subject to the relevant Parking Provider Terms.
          </li>
          <li>
            <strong class=" px-2 text-secondary">5.2.2</strong>
            The Parking Provider Terms govern the provision of the parking
            services and are separate from these terms, which govern the booking
            process.
          </li>
          <li>
            <strong class=" px-2 text-secondary">5.2.3</strong>
            You have read and understood the relevant Parking Provider Terms for
            the service you have booked
          </li>
          <li>
            <strong class=" px-2 text-secondary">5.2.4</strong>
            Claims related to the delivery of parking services must be directed
            to the Parking Provider, as their terms govern the supply and
            performance of these services.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 6 Making Bookings
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">6.1</strong>A booking is confirmed
            once you receive a booking reference via a Booking Confirmation.
            Retain this confirmation as it contains details on amending or
            canceling your booking (see Section 7).
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.2</strong>
            By completing a booking, you accept these terms and the Parking
            Provider Terms. We are not responsible for non-delivery of the
            Booking Confirmation due to incorrect contact details or email
            transmission issues.
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.3</strong>
            All parking services offered on the Website are subject to
            availability, and prices may change. We reserve the right to amend
            or discontinue services without notice
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.4</strong>
            If a Parking Provider cannot fulfill your booking, we will notify
            you and arrange a refund to the original payment method. We are not
            liable for any other losses arising from the Parking Provider’s
            inability to fulfill your booking
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.5</strong>
            It is your responsibility to provide accurate contact information
            when booking and to verify the details in the Booking Confirmation
            match your requested service
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.6</strong>
            Information you provide on the Website may be used by us or the
            Parking Provider
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.6.1</strong>
            For details on how we use your information, refer to our Privacy
            Policy
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.6.2</strong>
            For information on how the Parking Provider uses your data, consult
            their terms.
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.7</strong>
            For clarity, we retain a portion of the sale price of parking
            services and pass the remainder to the Parking Provider, reflecting
            our role as a booking agent.
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.8</strong>
            Please ensure you have your booking confirmation voucher and or
            booking reference with you when you travel. This will identify you
            as a Smart customer and enable the service provider to verify your
            booking.
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.9</strong>
            It's your responsibility to obtain chauffeur's telephone number and
            details of arrival procedure before departing for the airport - any
            missed bookings, flights or other problems arising from your failure
            to obtain this information will not be recompensed by Smart or any
            of&nbsp;our&nbsp;affiliates
          </li>
          <li>
            <strong class=" px-2 text-secondary">6.10</strong>
            Please ensure you have your booking confirmation voucher/ and or
            booking reference with you when you travel. This will identify you
            as a smart/compare customer and enable the service provider to
            verify your booking. .
          </li>{" "}
          <li>
            <strong class=" px-2 text-secondary">6.11</strong>
            it's your responsibility to obtain chauffeur's telephone number and
            details of arrival procedure before departing for the airport - any
            missed bookings, flights or other problems arising from your failure
            to obtain this information will not be recompensed by smart/ compare
            or any of&nbsp;our&nbsp;affiliates.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 7 Prices
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">7.1</strong>
            We strive to offer the best choice of parking services at
            competitive prices. Prices may vary seasonally and are subject to
            change without notice.
          </li>
          <li>
            <strong class=" px-2 text-secondary">7.2</strong>
            Where applicable, bookings are subject to a non-refundable booking
            fee.
          </li>
          <li>
            <strong class=" px-2 text-secondary">7.3</strong>
            Daily prices may vary based on the date and length of stay
          </li>
          <li>
            <strong class=" px-2 text-secondary">7.4</strong>
            Some parking services may include additional surcharges imposed by
            the Parking Provider, which are payable in addition to the
            advertised price.
          </li>
          <li>
            <strong class=" px-2 text-secondary">7.5</strong>
            Special offers, vouchers, and promo codes cannot be combined unless
            explicitly stated.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 8 Service Reviews Policy
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">8.1</strong>
            All reviews related to parking services should be submitted directly
            on the Parking Provider's review platform. Customers may also
            receive an email from us inviting them to share feedback about their
            experience. Any reviews displayed on our Website are genuine and
            provided by customers who have used the parking services.
          </li>
          <li>
            <strong class=" px-2 text-secondary">8.2</strong>
            Reviews about the parking services cannot be posted on our review
            platforms (e.g., Trustpilot, Google, etc.), as we are not the
            Parking Providers but only facilitate price comparison for car
            parks.
          </li>
          <li>
            <strong class=" px-2 text-secondary">8.3</strong>
            Any reviews about parking services left on our review platforms will
            be disputed. If such reviews are not removed immediately upon our
            request, we reserve the right to take legal action. Additionally,
            any associated administrative or legal costs will be added to the
            claim.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 9 Payment
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">9.1</strong>
            Payment for parking services must be made online and in advance.
            Accepted payment methods are listed on our Website. We reserve the
            right to decline your booking if your card is declined for any
            reason or if the card has been used fraudulently or without the
            cardholder's permission.
          </li>
          <li>
            <strong class=" px-2 text-secondary">9.2</strong>
            All prices are displayed in the currency of the selected country and
            include sales tax where applicable.
          </li>
          <li>
            <strong class=" px-2 text-secondary">9.3</strong>
            If you make a booking using a non-UK credit or debit card, your
            account will be charged based on your card issuer’s exchange rate on
            the transaction date, and you may incur additional conversion fees.
          </li>
          <li>
            <strong class=" px-2 text-secondary">9.4</strong>
            VAT receipts can only be provided where the Parking Provider has
            agreed to allow us to do so and has supplied us with the necessary
            VAT details. If we do not have this information, we will be unable
            to issue a VAT receipt.
          </li>
          <li>
            <strong class=" px-2 text-secondary">9.5</strong>
            If you request a VAT receipt and we lack the Parking Provider’s
            consent or details, we will contact the Parking Provider to obtain
            the required information. Once received, we will process your
            request
          </li>
          <li>
            <strong class=" px-2 text-secondary">9.6</strong>
            Please note, we cannot guarantee that the Parking Provider will
            agree to provide the necessary details. If you require a VAT receipt
            urgently, we recommend contacting the Parking Provider directly.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 10 Amending Your Booking
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">10.1</strong>
            If your booking is marked as "NON-FLEX," otherwise designated as
            unamendable, it cannot be changed. This is due to the conditions set
            by the Parking Provider
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.2</strong>
            You cannot change the date of your parking booking. In some cases,
            we may be able to amend the booking without requiring a
            cancellation, but this is subject to the conditions set by the
            Parking Provider. If an amendment isn't possible, you will need to
            cancel the existing booking and create a new one. The cancellation
            policy outlined below will apply.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.3</strong>
            Unless stated otherwise, amendments can only be made to details such
            as flight numbers, passenger information, or vehicle details
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.4</strong>
            You can also advise the Product Provider of any changes to your
            return dates/times on your arrival.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.5</strong>
            If you have booked a parking provider that allows amendments, you
            may modify your booking only by providing at least 72 hours' notice
            before the scheduled usage date. If you have purchased Cancellation
            Cover, you may amend your booking with a minimum of 24 hours' notice
            prior to the booked date.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.6</strong>
            Please note that amendment requests can only be processed during our
            office hours (Monday to Friday, 9:00 AM - 5:00 PM GMT) and are
            subject to the notice period specified above. If you submit a
            request outside of office hours, it will only be considered once
            office hours resume. If the request falls outside the required
            notice period for the parking provider, it will not be accepted.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.7</strong>
            To request an amendment to your booking, please contact us through
            one of the following methods:
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.7.1</strong>
            Send a request via the Members Area, available here.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.7.2</strong>
            Email us at info@comparemyparkingdeals.co.uk
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.7.3</strong>
            Use the contact form available here
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.7.4</strong>
            Reach us via the live chat function on our website
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.8</strong>
            Ensure you provide the email used for booking, your booking
            reference, and details of the requested amendment when contacting
            us.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.9</strong>
            Emails will be responded to within 72 business hours. For bookings
            within the next 72 hours, please use our live chat during office
            hours.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.10</strong>
            Once an amendment request is received, we will contact the Parking
            Provider. Fulfillment is subject to availability and may incur
            additional charges.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.11</strong>
            Amendments are only confirmed once you receive a confirmation email
            from us or the Parking Provider. If the request cannot be fulfilled,
            you may need to cancel and rebook, subject to the cancellation
            policy.
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.12</strong>
            Amendments are agreements between you and the Parking Provider. We
            are not liable if your requested amendment is declined
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.13</strong>
            Any amendments related to extended bookings or date changes will
            incur a £10 charge, in addition to any difference in the price quote
          </li>
          <li>
            <strong class=" px-2 text-secondary">10.14</strong>
            Any amendments related to vehicle or personal details will incur a
            £15 charge.
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 11 Cancelling Your Booking
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">11.1</strong>
            Regulation 28(1)(h) of the Consumer Contracts (Information,
            Cancellation, and Additional Charges) Regulations 2013 exempts
            leisure services on specific dates from the 14-day "cooling-off"
            period. This applies to bookings made through our Website, and
            cancellations are subject to these terms
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.2</strong>
            Bookings marked "NON-FLEX," or otherwise non-cancellable cannot be
            canceled due to Parking Provider conditions. Cancellation and refund
            rules specific to certain services are outlined in the product
            details and your Booking Confirmation
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.3</strong>
            The SMS confirmation service is non-refundable. Ensure your mobile
            device is compatible before purchasing.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.4</strong>
            Transaction fees charged by banks or payment providers are
            non-refundable.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.5</strong>
            Failure to meet booking requirements may result in no refund for
            unused services.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.6</strong>
            Any administrative fees paid for changes or amendments are
            non-refundable.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.7</strong>
            Refunds are not available if the booking date has passed.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.8</strong>
            Unless otherwise stated, no refunds are available for unused or
            partially used services.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.9</strong>
            Cancellable bookings require at least 72 hours' notice before the
            booking date. If Cancellation Cover is purchased, notice must be
            given at least 24 hours before the booking date.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.10</strong>
            Cancellation Cover does not apply to same-day bookings or specific
            products where indicated.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.11</strong>
            Cancellation requests can only be processed during our office hours
            (Monday to Friday, 9:00 AM - 5:00 PM GMT). Late requests will not be
            accepted.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.12</strong>
            To cancel your booking, contact us via:
          </li>
          <ul class="px-5">
            <li >
              Email at info@comparemyparkingdeals.co.uk.
            </li>
            <li >
              The contact form <a href="/contact-us.php">here</a>
            </li>
            <li >Live chat on our Website.</li>
          </ul>
          <li>
            <strong class=" px-2 text-secondary">11.13</strong>
            For bookings within 7 days, please use the specified contact options
            above.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.14</strong>
            Provide your booking reference and the email used during booking
            when requesting a cancellation.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.15</strong>
            Cancellation requests must be submitted directly to us. Requests
            made to the Parking Provider are not valid.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.16.1</strong>
            If Cancellation Cover is purchased, a full refund (minus £20.00
            cancellation fees) will be processed within 7–10 working days.
          </li>
          <li>
            <strong class=" px-2 text-secondary">11.16.2</strong>
            Without Cancellation Cover, a full refund (minus £20.00 cancellation
            fees) will be processed within 7–10 working days
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 12 HOW CAN I COMPLAIN ABOUT MY BOOKING?
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">12.1</strong>
            If you experience any issues with the Website, please notify us in
            writing by emailing info@comparemyparkingdeals.co.uk.
          </li>
          <li>
            <strong class=" px-2 text-secondary">12.2</strong>
            If you encounter any issues with the parking provider you booked
            through the Website before using their services, please contact us
            at info@comparemyparkingdeals.co.uk. We will guide you on the next steps
          </li>
          <li>
            <strong class=" px-2 text-secondary">12.3</strong>
            If you experience any issues with the parking provider during or
            after using their services, please contact them directly to give
            them the opportunity to resolve the issue. If possible, notify the
            parking provider about the issue before leaving their premises.
            Additionally, please inform us that you've encountered a problem and
            contacted the parking provider by emailing
            info@comparemyparkingdeals.co.uk.
          </li>
          <li>
            <strong class=" px-2 text-secondary">12.4</strong>
            If you do not receive a satisfactory response from the parking
            provider within 7 days of using their services, please reach out to
            us at info@comparemyparkingdeals.co.uk. If we do not hear from you
            within 14 days after your use of the parking provider, we may assume
            the issue has been resolved appropriately by the provider
          </li>
        </ul>
      </div>
      <div>
        <h2 class="md:text-2xl text-[18px] font-semibold text-secondary mt-6">
          Section : 13 GENERAL
        </h2>
        <ul>
          <li>
            <strong class=" px-2 text-secondary">13.1</strong>
            If you do not receive a satisfactory response from the parking
            provider within 7 days of using their services, please reach out to
            us at info@comparemyparkingdeals.co.uk. If we do not hear from you
            within 14 days after your use of the parking provider, we may assume
            the issue has been resolved appropriately by the provider
          </li>
          <li>
            <strong class=" px-2 text-secondary">13.2</strong>
            These terms, along with our privacy policy and cookies policy, form
            the entire agreement between you and us regarding your use of our
            Website to make bookings for parking providers, and supersede any
            prior agreements.
          </li>
          <li>
            <strong class=" px-2 text-secondary">13.3</strong>
            Any failure or delay by us in exercising any right under these terms
            will not waive that right, nor will any single or partial exercise
            of a right prevent further exercise of that right.
          </li>
          <li>
            <strong class=" px-2 text-secondary">13.4</strong>
            Written notice includes notice sent by email.
          </li>
          <li>
            <strong class=" px-2 text-secondary">13.5</strong>
            These terms, and your access to and use of the Website, will be
            governed by and construed in accordance with the laws of England.
          </li>
          <li>
            <strong class=" px-2 text-secondary">13.6</strong>
            You may bring claims against us in the English courts. If you reside
            in Wales, Scotland, or Northern Ireland, you may also bring claims
            against us in the courts of your country of residence. We may bring
            claims against you in the courts of your country of residence.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TermsAndConditions;
